var _style, _circle, _path, _path2, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoSurveys = function SvgNoSurveys(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "no-surveys_svg__Layer_1",
    viewBox: "0 0 600 520"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "no-surveys_svg__clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 308.99,
    cy: 295.42,
    r: 153.73,
    style: {
      strokeWidth: 0,
      fill: "none"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".no-surveys_svg__cls-13,.no-surveys_svg__cls-15,.no-surveys_svg__cls-3,.no-surveys_svg__cls-4,.no-surveys_svg__cls-6,.no-surveys_svg__cls-7{stroke-width:0}.no-surveys_svg__cls-3{fill:#ff67a9}.no-surveys_svg__cls-4{fill:#03172c}.no-surveys_svg__cls-7{fill:#0feaac}.no-surveys_svg__cls-6{fill:#7885cb}.no-surveys_svg__cls-15{fill:#ff9d00}.no-surveys_svg__cls-13{fill:#fff}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 230.78,
    cy: 142.24,
    r: 12.88,
    className: "no-surveys_svg__cls-6"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 308.99,
    cy: 295.42,
    r: 153.73,
    style: {
      fill: "#c5cae8",
      opacity: 0.59,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#no-surveys_svg__clippath)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 310.9,
    cy: 362.3,
    r: 131.22,
    style: {
      fill: "#303f9f",
      strokeWidth: 0
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301.78 279.88c.3 10.7-8.11 19.57-18.78 19.88-10.67.3-19.57-8.08-19.88-18.78-.3-10.67 8.11-19.54 18.78-19.85 1.25-.04 2.46.05 3.66.26 5.22.82 9.75 3.74 12.69 7.91 2.12 2.98 3.41 6.62 3.52 10.57ZM354.05 279.88c.3 10.7-8.08 19.57-18.75 19.88-10.67.3-19.57-8.08-19.88-18.78s8.11-19.54 18.78-19.85c1.25-.04 2.46.05 3.66.26 5.22.82 9.78 3.77 12.73 7.97 2.09 2.98 3.35 6.6 3.46 10.52Z",
    className: "no-surveys_svg__cls-13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360.68 318.56a4.222 4.222 0 1 0 8.441-.241 4.222 4.222 0 0 0-8.441.241ZM254.36 317.36a4.216 4.216 0 0 1 4.34 4.1c.07 2.33-1.77 4.28-4.1 4.34s-4.28-1.77-4.34-4.1a4.216 4.216 0 0 1 4.1-4.34ZM252.68 258.52c4.55-16.94 23.21-23.56 37.45-13.31 2.38 1.71-.6 5.15-2.95 3.45-11.36-8.18-26.41-2.78-30.04 10.75-.75 2.81-5.22 1.95-4.46-.88ZM357.36 256.55c-4.39-13.29-19.72-17.83-30.6-9.02-2.26 1.83-5.42-1.43-3.15-3.28 13.63-11.04 32.64-5.5 38.14 11.16.92 2.79-3.49 3.89-4.4 1.13Z",
    className: "no-surveys_svg__cls-6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 289.32,
    cy: 286.98,
    r: 9.99,
    className: "no-surveys_svg__cls-4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.6,
    cy: 286.98,
    r: 9.99,
    className: "no-surveys_svg__cls-4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M328.78 350.01c-.19 1-.41 2-.68 2.95-.05.24-.12.49-.19.73-2.42 8.06-7.55 13.77-18.12 13.58-8.86-.17-13.43-6.59-15.73-15.19-2.76-10.23-2.25-23.52-1.81-32.94.05-1.44.12-2.78.17-4h37.17c-.05 1.25-.07 2.59-.05 4 .07 9.13 1.12 21.12-.76 30.87Z",
    className: "no-surveys_svg__cls-13"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.1 352.97c-.05.24-.12.49-.19.73-2.42 8.06-7.55 13.77-18.12 13.58-8.86-.17-13.43-6.59-15.73-15.19 11.35-3.42 22.98-3.15 34.04.88Z",
    style: {
      fill: "#ec0080",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.37 178.73c6.21 0 11.23-4.9 11.23-10.89S155.57 157 149.37 157s-11.23 4.85-11.23 10.84 5.03 10.89 11.23 10.89Z",
    style: {
      opacity: 0.59,
      fill: "#c5cae8",
      isolation: "isolate",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.85 496.48c4.92 0 8.91-3.85 8.91-8.6s-3.99-8.64-8.91-8.64-8.92 3.89-8.92 8.64 3.99 8.6 8.92 8.6Z",
    style: {
      fill: "#ff9d00",
      isolation: "isolate",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.17 510.42c16.19 0 29.31-12.78 29.31-28.41s-13.12-28.29-29.31-28.29-29.31 12.66-29.31 28.29 13.12 28.41 29.31 28.41Z",
    style: {
      isolation: "isolate",
      fill: "#0feaac",
      strokeWidth: 0
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M574.51 148.74c4.19 0 7.58-3.31 7.58-7.35s-3.39-7.32-7.58-7.32-7.58 3.27-7.58 7.32 3.39 7.35 7.58 7.35Z",
    className: "no-surveys_svg__cls-15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M385.75 515c6.27 0 11.35-4.91 11.35-10.96s-5.08-10.96-11.35-10.96-11.34 4.91-11.34 10.96S379.49 515 385.75 515Z",
    className: "no-surveys_svg__cls-3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M508.91 399.66c10.74 0 19.45-8.38 19.45-18.75s-8.7-18.79-19.45-18.79-19.45 8.41-19.45 18.79 8.7 18.75 19.45 18.75Z",
    className: "no-surveys_svg__cls-15"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M202.41 34.97c3.6 0 6.52-2.82 6.52-6.29s-2.92-6.31-6.52-6.31-6.52 2.82-6.52 6.31 2.92 6.29 6.52 6.29Z",
    className: "no-surveys_svg__cls-7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M242.06 69.84c10.17 0 18.42-8.24 18.42-18.42s-8.24-18.41-18.42-18.41-18.41 8.24-18.41 18.41 8.24 18.42 18.41 18.42Z",
    className: "no-surveys_svg__cls-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.4 459c49.32 0 89.3-39.98 89.3-89.33s-39.98-89.27-89.3-89.27-89.3 39.98-89.3 89.27S51.08 459 100.4 459Z",
    style: {
      fill: "#ff5b00",
      strokeWidth: 0
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M181.06 230.51c43.76 0 79.24-35.48 79.24-79.2s-35.47-79.27-79.24-79.27-79.23 35.48-79.23 79.27 35.47 79.2 79.23 79.2Z",
    className: "no-surveys_svg__cls-15"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M147.45 366.52v-15.45c0-4.19-3.4-7.6-7.6-7.6H111.2v23.05h36.25ZM60.95 343.47c-4.2 0-7.6 3.4-7.6 7.6v15.45H89.6v-23.05H60.95ZM132.74 419.24c4.2 0 7.6-3.4 7.6-7.6v-40.68h-29.13v48.27h21.53ZM60.47 370.96v40.68c0 4.19 3.4 7.6 7.6 7.6h21.54v-48.27H60.48ZM131.69 317.87c-1.88-1.9-5.4-4.19-11.27-3.94-6.14.25-12.44 3.17-18.22 8.45-.63.58-1.23 1.16-1.8 1.74-.57-.58-1.17-1.16-1.8-1.74-5.78-5.28-12.08-8.2-18.22-8.45-5.87-.24-9.39 2.05-11.27 3.94-2.31 2.33-3.59 5.48-3.59 8.86 0 6.84 4.92 11.99 11.44 11.99h46.87c6.52 0 11.44-5.16 11.44-11.99 0-3.38-1.27-6.53-3.59-8.86Zm-54.72 11.74c-2.3 0-2.33-2.76-2.33-2.88 0-.56.12-1.62.95-2.45 1.03-1.04 2.72-1.26 3.96-1.26.15 0 .31 0 .46.01 4.98.2 9.59 3.33 13.02 6.58H76.97Zm46.87 0H107.8c.18-.17.36-.34.55-.51 2.91-2.66 7.43-5.87 12.45-6.07.16 0 .31-.01.46-.01 1.24 0 2.93.22 3.96 1.26.83.83.95 1.89.95 2.45 0 .12-.03 2.88-2.33 2.88ZM227.25 120.88l-14.37.29-.11-5.32c2.65-.26 4.81-2.53 4.76-5.4-.06-2.87-2.54-5.26-5.41-5.2l-63.24 1.26c-2.87.06-5.26 2.54-5.2 5.41a5.309 5.309 0 0 0 4.97 5.21l.11 5.32-14.37.29c-2.87.06-5.26 2.54-4.98 5.41l.08 4.2c.29 14.37 10.27 26.78 24.28 30.26l7.33 1.84.23.22c.23.44.46.66.68.88 3.61 3.25 7.63 5.6 12.52 6.82l.15 7.75c.04 1.76-1.48 3.35-3.24 3.39l-5.75.11c-2.44.05-4.17 2.07-4.12 4.28l.11 5.31c.05 2.43 2.07 4.17 4.29 4.12l33.17-.66c2.43-.05 4.16-2.08 4.11-4.29l-.11-5.31c-.05-2.43-2.07-4.16-4.28-4.11l-5.75.11c-1.78.04-3.35-1.49-3.39-3.25l-.15-7.75c4.84-1.2 9-3.71 12.23-7.32.21-.45.43-.68.65-.9v-.22l7.26-2.13c13.86-4.04 23.33-16.83 23.04-31.21l-.08-4.2c-.06-2.87-2.54-5.26-5.41-5.2Zm-87.36 12.35 9.29-.19c.31 4.41 1.34 11.48 3.91 18.5-7.58-3.17-12.6-10.14-13.2-18.31Zm56.25 2.86-4.99 4.98c-.65.67-1.06 1.79-.83 2.89l1.47 6.82c.24.66.03 1.33-.63 1.78-.66.46-1.31.69-1.98.26l-6.26-3.18c-.45-.21-1.11-.42-1.55-.41s-1.11.02-1.55.25l-6.13 3.43c-.65.24-1.32.25-1.99-.17-.45-.44-.9-1.09-.7-1.76l1.2-6.87c.2-1.11-.04-2.22-.95-2.86l-5.18-4.77c-.45-.42-.69-1.08-.92-1.52.21-.67.87-1.13 1.53-1.14l7.05-1.02c1.11-.24 1.98-.93 2.4-1.83l2.97-6.47c.21-.67.87-1.13 1.53-1.14s1.33.42 1.56 1.08l3.22 6.34c.46.88 1.36 1.53 2.47 1.73l7.1.73c.88-.02 1.33.42 1.56 1.08.24.66.03 1.32-.41 1.77Zm13.57 14.33c2.29-7.12 3.02-14.22 3.16-18.64l9.29-.19c-.28 8.19-5 15.36-12.45 18.83Z",
    className: "no-surveys_svg__cls-13"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M549.25 110.58c0 13.45-2.61 26.27-7.2 38.1-7.97-9.3-19.64-15.33-32.84-15.33-5.32 0-10.41.95-15.1 2.7-14.03 5.21-24.65 17.48-27.51 32.5-.51 2.65-.78 5.39-.78 8.19 0 13.04 5.88 24.61 15 32.56-11.57 4.37-24.06 6.86-37.15 6.86-58.31 0-105.58-47.27-105.58-105.59S385.35 5 443.66 5s105.59 47.27 105.59 105.58Z",
    className: "no-surveys_svg__cls-7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M443.69 61.93c-12.15 0-22.05 10.1-22.05 22.3s9.89 22.29 22.05 22.29 22.05-10.08 22.05-22.29-9.89-22.3-22.05-22.3Zm-11.48 54.7c-7.63 0-14.12 3.99-18.31 9.45s-6.43 12.38-6.43 19.43v3.9c0 7.28 5.95 13.39 13.25 13.39h45.87c7.3 0 13.27-6.11 13.27-13.39v-3.9c0-7.05-2.25-13.97-6.43-19.43s-10.69-9.45-18.32-9.45H432.2ZM483.51 58.95c-7.39 0-13.39 6.2-13.39 13.55s6 13.55 13.39 13.55 13.39-6.2 13.39-13.55-6-13.55-13.39-13.55Zm-5.68 41.94a5.624 5.624 0 0 0-5.47 4.14c-.67 2.46.41 5.07 2.62 6.34 6.39 3.74 11.14 12.33 13.04 19.44a5.607 5.607 0 0 0 5.42 4.17h7.13c5.85 0 10.45-4.99 10.45-10.69v-2.57c0-5-1.5-9.85-4.44-13.8s-7.7-7.04-13.3-7.04h-15.46ZM403.87 58.37c-7.7 0-13.97 6.46-13.97 14.13s6.27 14.13 13.97 14.13 13.97-6.46 13.97-14.13-6.27-14.13-13.97-14.13Zm-9.79 42.52c-5.6 0-10.36 3.09-13.3 7.04-2.94 3.95-4.48 8.81-4.48 13.8v2.57c0 5.7 4.64 10.69 10.49 10.69h5.67c2.55 0 4.79-1.71 5.44-4.17 1.75-6.52 7.83-15.56 14.46-19.44a5.618 5.618 0 0 0 2.62-6.33 5.61 5.61 0 0 0-5.44-4.15h-15.46Z",
    className: "no-surveys_svg__cls-13"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 512.29,
    cy: 178.3,
    r: 47.72,
    style: {
      fill: "#303f9e",
      strokeWidth: 0
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M527.54 154.85c-5.09-1.12-10.72 1.27-14.23 7.9-.39.81-1.62.77-2.04 0-3.39-6.63-9.18-8.95-14.27-7.87-6.55 1.43-10.1 7.02-9.41 12.99.77 6.86 5.86 13.23 10.1 18.66 1.74 2.2 9.14 10.56 12.73 14.61 1 1.16 2.89 1.16 3.89 0 3.55-4.05 10.91-12.45 12.65-14.65 4.24-5.48 9.25-11.84 10.02-18.7.69-5.98-2.89-11.57-9.45-12.96Z",
    className: "no-surveys_svg__cls-13"
  })));
};
export default SvgNoSurveys;